var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickboxGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2.5,
    width: 4,
    height: 4,
    fill: "#1B2436"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 7.5,
    width: 4,
    height: 4,
    fill: "#1B2436"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 12.5,
    width: 4,
    height: 4,
    fill: "#1B2436"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 2.5,
    width: 4,
    height: 4,
    fill: "#1B2436"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 7.5,
    width: 4,
    height: 4,
    fill: "#1B2436"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12.5,
    width: 4,
    height: 4,
    fill: "#1B2436"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 2.5,
    width: 4,
    height: 4,
    fill: "#1B2436"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7.5,
    width: 4,
    height: 4,
    fill: "#1B2436"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12.5,
    width: 4,
    height: 4,
    fill: "#1B2436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickboxGrid);
export default __webpack_public_path__ + "static/media/tickboxGrid.768ff49a32e0c067a88195067c5e01a6.svg";
export { ForwardRef as ReactComponent };